import {getZuobiaoInfo} from '@/../static/pubjs/index'
export default {
  install(Vue, options) {

    //拷贝一个对象
    Vue.prototype.mycopyobj=function(obj){

      //对于有函数对象的要进行处理
      var newobj = this.mycopyobj_copyfunc(obj)
      return newobj
    },
    // 对象的中函数的赋值操作
      Vue.prototype.mycopyobj_copyfunc = function (obj) {
      var newobj = JSON.parse(JSON.stringify(obj))
      var one = ''
      var t = ''
      for (var mykey in obj) {
        one = obj[mykey]
        t = typeof (one)
        if (t == 'object') {
          var newone = this.mycopyobj_copyfunc(one)
          newobj[mykey] = newone
        } else if (t == 'function') {
          newobj[mykey] = obj[mykey]
        }

      }
      return newobj
    },
    Vue.prototype.ArrCountbyField = function (arrdata, fieldname)
    {
      var result = []
      var arrindex = {}
      for (var i = 0; i < arrdata.length; i++) {
        var name = arrdata[i][fieldname]
        if (arrindex[name] === undefined) {
          arrindex[name] = 1
        } else {
          arrindex[name] = arrindex[name] * 1 + 1
        }
      } // for i
      for (var key in arrindex) {
        result.push({'name': key, 'value': arrindex[key]})
      }
      // 排序函数
      var comparefunc = function (obj1, obj2) {
        var val1 = obj1.name
        var val2 = obj2.name
        if (val1 < val2) {
          return 1
        } else if (val1 > val2) {
          return -1
        } else {
          return 0
        }
      }
      var resultok = result.sort(comparefunc)
      return resultok
    },
    Vue.prototype.ArrSumbyField = function (arrdata, fieldname, fieldsum)
    {
      var result = []
      var arrindex = {}
      for (var i = 0; i < arrdata.length; i++) {
        var name = arrdata[i][fieldname]
        var value = arrdata[i][fieldsum]
        if (arrindex[name] === undefined) {
          arrindex[name] = value
        } else {
          arrindex[name] = arrindex[name] * 1 + value * 1
        }
      } // for i
      for (var key in arrindex) {
        result.push({'name': key, 'value': arrindex[key]})
      }
      // 排序函数
      var comparefunc = function (obj1, obj2) {
        var val1 = obj1.name
        var val2 = obj2.name
        if (val1 < val2) {
          return 1
        } else if (val1 > val2) {
          return -1
        } else {
          return 0
        }
      }
      var resultok = result.sort(comparefunc)
      return resultok
    }
    Vue.prototype.Trim = function (str) {
      return str.replace(/(^\s*)|(\s*$)/g, "")
    },
      Vue.prototype.initbmap = function () {
        const AK = "AK密钥";
        const BMap_URL = "https://api.map.baidu.com/api?v=2.0&ak=" + AK + "&s=1&callback=onBMapCallback";
        return new Promise((resolve, reject) => {
          // 如果已加载直接返回
          if (typeof BMap !== "undefined") {
            resolve(BMap)
            return true
          }
          // 百度地图异步加载回调处理
          window.onBMapCallback = function () {
            console.log("百度地图脚本初始化成功...")
            resolve(BMap);
          }
          // 插入script脚本
          let scriptNode = document.createElement("script")
          scriptNode.setAttribute("type", "text/javascript")
          scriptNode.setAttribute("src", BMap_URL)
          document.body.appendChild(scriptNode)
        })
      },
      // 找找一个字符串在数组中是否存在 返回》0表示存在，-1表示不存在
      Vue.prototype.findstr = function (szstr, str) {
        for (var i = 0; i < szstr.length; i++) {
          if (szstr[i] == str)
            return i
        }
        return -1
      },
      
      Vue.prototype.getcfgitemtype = function (optionobj) {
        var itemtype = ''
        var element = optionobj['element']
        if (element == '' || element == undefined)
          return itemtype
        var find = element.indexOf(' ')
        if (find > 0) {
          itemtype = element.substring(1, find)
        }/*
        if (optionobj.name == '卡片图') {
          itemtype = 'card';
        }
        if (optionobj.name == '表格') {
          itemtype = 'table';
        }*/

        return itemtype

      },
     
      //获取图形的配置信息
      Vue.prototype.getcfgitemMain = function (onemodel) {
        let items = [];
        if (onemodel.cfgitem != undefined && onemodel.cfgitem != '') {
          items = JSON.parse(onemodel.cfgitem);
          return items; //数据库中存在的按照数据库的配置返回  20210308 lili
        }
        //为兼容原有的图表设置  原来的图表模型数据库中没有设置cfgitem字段，执行程序逻辑 20210308 lili
        let name = onemodel.name;
        let chartype = onemodel.chartype;
        let optionobj = {};
        if (onemodel.modelcfg) {
          optionobj = JSON.parse(onemodel.modelcfg);
        }
        if (chartype*1 == 1 || chartype*1 == 2 ) {
          //通用图形和业务图形
          items = this.getcfgitem(name,optionobj);
        } else if (chartype * 1 == 3) {
          //设计图形
          items = this.getcfgitemSmodel(optionobj);
        }
        return items
      },
      //获取设计图形的配置信息
      Vue.prototype.getcfgitemSmodel = function (optionobj) {
        var items = []
        var element = optionobj['element']
        let hlname = optionobj.hlname
        var find = element.indexOf(' ')
        if (find > 0) {
          var htmlelement = element.substring(1, find)
          if (htmlelement == 'input') {
            items.push({ 'name': '值', 'nametype': 'manual1', 'func': '' }) //手工输入
          } else if (htmlelement == 'textarea') {
            items.push({ 'name': '值', 'nametype': 'value', 'func': '' })
          } else if (htmlelement == 'hlcustom') {
            if (hlname == 'HLmatrix') {
              items = []
              items.push({ 'name': '行', 'nametype': 'row', 'func': '' }, { 'name': '列', 'nametype': 'column', 'func': '' }, { 'name': '值', 'nametype': 'value', 'func': '' })
            } else if (hlname == 'HLslicer') {
              items = []
              items.push({ 'name': '字段', 'nametype': 'value', 'func': 'distinct' })
            } else if (hlname == 'HLrichtext') {
              items = []
              items.push({ 'name': '值', 'nametype': 'manual1', 'func': '' })//输入，但是不在字段配置上输入
            } else if (hlname == 'HLsingleinput') {
              items = []
              items.push({ 'name': '值', 'nametype': 'manual1', 'func': '' }) //手工输入
            } else if (hlname == 'HLtable') {
              items = [];
              items.push({ 'name': '列', 'nametype': 'value', 'func': '' });
            } else if (hlname == 'HLcard') {
              items = [];
              items.push({ 'name': '值', 'nametype': 'value', 'func': '' });
            }
          }
        }

        return items

      },
      //此函数不再维护，暂时不能删除。如果要改变配置项，请直接在数据库中添加即可 2021-03-20 lili
      Vue.prototype.getcfgitem = function (name, optionobj) {
        var items = []
        var rettype = getZuobiaoInfo(optionobj)
        var optintitle = ''
        if (optionobj.title != undefined) {
          if (Object.prototype.toString.call(optionobj.title) === '[object Object]') {
            optintitle = optionobj.title.text
          } else if (Object.prototype.toString.call(optionobj.title) === '[object Array]') {
            optintitle = optionobj.title[0].text
          }
          if (optintitle == undefined) {
            optintitle = ''
          }
        }
        if(optintitle == '') {
          if(optionobj.name) {
            optintitle = optionobj.name;
          }
        }
        // -1未知  0 无坐标系  1 直角  2 单轴  3 极坐标  4 雷达坐标 5 地理坐标 6 日历坐标  7 平行坐标
        if (rettype === 0) {
          var ones = null
          if (Object.prototype.toString.call(optionobj.series) === '[object Object]') {
            ones = optionobj.series
          } else if (Object.prototype.toString.call(optionobj.series) === '[object Array]') {
            if (optionobj.series.length > 0) {
              ones = optionobj.series[0]
            }
          }
          ///manual:此类型的nametype不参与数据获取
          if (ones.type === 'gauge') {
            items = [{ 'name': '值', 'nametype': 'value', 'func': '' }, { 'name': '最大值', 'nametype': 'maxvalue', 'func': '' }, { 'name': '最小值', 'nametype': 'minvalue', 'func': '' }]
          } else if (ones.type == 'wordCloud') {
            items = [{ 'name': '类别', 'nametype': 'group', 'func': 'distinct' }, { 'name': '值', 'nametype': 'value', 'func': '' }, { 'name': '不包含', 'nametype': 'filter', 'func': '' }, { 'name': '排除词', 'dis':'输入内容,逗号分隔(全角半角均可)','nametype': 'manual', 'func': '' },{'name':'最大词个数','dis':'输入数字,0表示全部','nametype':'manual','func':''}]
          } else if (ones.type == 'graph') {
            items = [{ 'name': '源节点', 'nametype': 'sourcevalue', 'func': '' }, { 'name': '目标节点', 'nametype': 'targetvalue', 'func': '' }, { 'name': '关系名称', 'nametype': 'linkvalue', 'func': '' },
            { 'name': '源节点图标url', 'nametype': 'source-u-value', 'func': '' }, { 'name': '目标节点图标url', 'nametype': 'target-u-value', 'func': '' },
            { 'name': '源节点size', 'nametype': 'source-s-value', 'func': '' }, { 'name': '目标节点size', 'nametype': 'target-s-value', 'func': '' }
            ]
            if (optintitle == '关系气泡图' || optintitle == '关系趋势图') {
              items = [{ 'name': '源节点', 'nametype': 'sourcevalue', 'func': '' }, { 'name': '目标节点', 'nametype': 'targetvalue', 'func': '' }, { 'name': '关系名称', 'nametype': 'linkvalue', 'func': '' },
              { 'name': '源节点size', 'nametype': 'source-s-value', 'func': '' }, { 'name': '目标节点size', 'nametype': 'target-s-value', 'func': '' },
              { 'name': '源节点类别', 'nametype': 'sourcecategory', 'func': '' },
              { 'name': '目标节点类别', 'nametype': 'targetcategory', 'func': '' },
              ]
            }
            if (name == '时序关系图') {
              items = [
                { 'name': '时序', 'nametype': 'group', 'func': '' },
                { 'name': '源节点', 'nametype': 'sourcevalue', 'func': '' }, { 'name': '目标节点', 'nametype': 'targetvalue', 'func': '' }, { 'name': '关系名称', 'nametype': 'linkvalue', 'func': '' },
                { 'name': '源节点size', 'nametype': 'source-s-value', 'func': '' }, { 'name': '目标节点size', 'nametype': 'target-s-value', 'func': '' },
                { 'name': '源节点类别', 'nametype': 'sourcecategory', 'func': '' },
                { 'name': '目标节点类别', 'nametype': 'targetcategory', 'func': '' },
              ]
            }
          } else {
            items = [{ 'name': '分组', 'nametype': 'group', 'func': 'distinct' }, { 'name': '值', 'nametype': 'value', 'func': '' }]
            if (ones.type === 'sunburst' || ones.type === 'treemap') {
              items.splice(1, 0, { 'name': '详细信息', 'nametype': 'detailvalue', 'func': 'distinct' })
            }
          }
        } else if (rettype === 1) {
          var xyitems = [{ 'name': 'X轴', 'nametype': 'xAxis', 'func': 'distinct' }, { 'name': '值', 'nametype': 'value', 'func': '' }, { 'name': '分组', 'nametype': 'group', 'func': 'distinct' }]

          var s = optionobj.series
          if (optintitle == '堆积条形图' || optintitle == '簇状条形图') {
            //条形图
            items = [{ 'name': 'Y轴', 'nametype': 'yAxis', 'func': '' }, { 'name': '值', 'nametype': 'value', 'func': '' }, { 'name': '分组', 'nametype': 'group', 'func': 'distinct' }]
          } else if (optintitle == '子弹图') {
            items = [{ 'name': 'Y轴', 'nametype': 'yAxis', 'func': '' }, { 'name': '实际值', 'nametype': 'value', 'func': '' }, { 'name': '目标值', 'nametype': 'value', 'func': '' }]
          } else if (optintitle == 'RFM模型') {
            items = [{ 'name': 'RFM分类', 'nametype': 'yAxis', 'func': '' }, { 'name': '客户数量分布', 'nametype': 'value', 'func': '' }, { 'name': '消费金额分布', 'nametype': 'value', 'func': '' }]
          } else if (name == '折线和柱状图') {
            items = [{ 'name': 'X轴', 'nametype': 'xAxis', 'func': '' }, { 'name': '折线值', 'nametype': 'value', 'func': '' }, { 'name': '柱状值', 'nametype': 'value', 'func': '' }]
          } else {
            if (Object.prototype.toString.call(s) === '[object Object]') {
              items = xyitems
              if (s.type === 'scatter') {
                items.push({ 'name': '大小', 'nametype': 'size', 'func': '' })
              } else if (s.type === 'candlestick') {
                items = [{ 'name': 'X轴', 'nametype': 'xAxis', 'func': '' }]
                items.push({ 'name': '开盘价', 'func': '', 'nametype': 'value' })
                items.push({ 'name': '收盘价', 'func': '', 'nametype': 'value' })
                items.push({ 'name': '最高价', 'func': '', 'nametype': 'value' })
                items.push({ 'name': '最低价', 'func': '', 'nametype': 'value' })
                items.push({ 'name': '交易量', 'func': '', 'nametype': 'value' })
              }
            } else if (Object.prototype.toString.call(s) === '[object Array]') {
              if (s.length > 1) {
                if (s[0].type === 'scatter') {
                  items = xyitems
                  items.push({ 'name': '大小', 'nametype': 'size', 'func': '' })
                  // items.push({'name': '大小', 'nametype': 'yAxis', 'func': 'sum' })
                } else if (s[0].type === 'candlestick') {
                  items = [{ 'name': 'X轴', 'nametype': 'xAxis', 'func': 'distinct' }]
                  items.push({ 'name': '开盘价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '收盘价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '最高价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '最低价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '交易量', 'func': '', 'nametype': 'value' })
                } else {
                  items.push({ 'name': 'X轴', 'nametype': 'xAxis', 'func': '' })
                  for (var y = 0; y < s.length; y++) {
                    // items.push()
                    items.push({ 'name': s[y].name, 'nametype': 'value', 'func': '' })
                  }
                }
              } else {
                if (s[0].type === 'scatter') {
                  items = xyitems
                  items.push({ 'name': '大小', 'nametype': 'size', 'func': '' })
                  // items.push({'name': '大小', 'nametype': 'yAxis', 'func': 'sum' })
                } else if (s[0].type === 'candlestick') {
                  items = [{ 'name': 'X轴', 'nametype': 'xAxis', 'func': '' }]
                  items.push({ 'name': '开盘价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '收盘价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '最高价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '最低价', 'func': '', 'nametype': 'value' })
                  items.push({ 'name': '交易量', 'func': '', 'nametype': 'value' })
                } else {
                  items = xyitems
                }
              }
            }
          }
        } else if (rettype === 2) {
          items = [{ 'name': 'X轴', 'nametype': 'xAxis', 'func': '' }, { 'name': '分组', 'nametype': 'group', 'func': '' }, { 'name': '大小', 'nametype': 'size', 'func': '' }]
        } else if (rettype === 3) {
          items = [{ 'name': '径向轴', 'nametype': 'radiusAxis', 'func': '' }, { 'name': '角度轴', 'nametype': 'angelAixs', 'func': '' }, { 'name': '值', 'nametype': 'value', 'func': '' }]
        } else if (rettype === 4) {
          // 雷达坐标系
          items = [{ 'name': '图例', 'nametype': 'legend', 'func': '' }, { 'name': '度量维度', 'nametype': 'group', 'func': '' }, { 'name': '值', 'nametype': 'value', 'func': '' }]
        } else if (rettype === 5) {
          //地理
          if (optionobj.name == '中国散点地图' || optionobj.name == '中国热力地图' || optionobj.name == '北京热力地图') {
            items = [{ 'name': '地名字段', 'nametype': 'group', 'func': '' }, { 'name': '值', 'nametype': 'value', 'func': '' }]
          }
        } else if (rettype === 6) {
          //日历
        } else if (rettype === 7) {

        }
        return items
      },
      //根据nametype获取类别  同一类别的可以互换
      // value   group:(group legend ) axis:x轴 y轴 角度轴等等  unkown
      Vue.prototype.getNameTypeClass = function (nametype) {
        let myclass = 'unkown'
        if (nametype == 'value' || nametype == 'source-s-value' || nametype == 'target-s-value'
          || nametype == 'maxvalue' || nametype == 'minvalue' || nametype == 'size') {
          myclass = 'value'
        } else if (nametype == 'group' || nametype == 'sourcevalue' || nametype == 'targetvalue' || nametype == 'linkvalue'
          || nametype == 'source-u-value' || nametype == 'target-u-value' || nametype == 'sourcecategory' || nametype == 'targetcategory'
          || nametype == 'legend' || nametype == 'detailvalue' || nametype == 'filter'
          || nametype == 'row' || nametype == 'column') {
          myclass = 'group'
        } else if (nametype == 'xAxis' || nametype == 'yAxis' || nametype == 'radiusAxis' || nametype == 'angelAixs') {
          myclass = 'axis'
        }
        return myclass
      },
      // 百分比的高度或长度转化为具体的值
      Vue.prototype.change2Value = function (basevalue, off, strValue) {
        var value = 0
        var fuhao = strValue.indexOf('+')
        if (fuhao == -1)
          fuhao = strValue.indexOf('-')
        var baifenhao = strValue.indexOf('%')
        if (fuhao > 0) {// 符号前
          var qian = strValue.substring(0, fuhao)
          var hou = strValue.substring(fuhao + 1);
          if (baifenhao < fuhao) {//  前是百分号
            var per = this.toPoint(qian)
            value = basevalue * per + hou * 1 + off
          }
          else {// 后是百分号
            var per = this.toPoint(hou)
            value = basevalue * per + qian * 1 + off
          }
        }
        else {
          var per = this.toPoint(strValue)
          value = (basevalue * per).toFixed(2) + off
        }
        return value
      },
      //  百分比转小数
      Vue.prototype.toPoint = function (percent) {
        var str = percent.replace("%", "");
        str = str / 100;
        return str;
      },
      // 获取当前时间
      Vue.prototype.getCurdate = function () {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();

        var curday = '';
        month = month * 1 + 1
        if (month * 1 < 10)
          month = '0' + month
        if (day * 1 < 10)
          day = '0' + day

        curday = year + '-' + month + '-' + day
        return curday
      },

      //**************本文件中的图表的配置信息都是基于echart的*******************
      //对齐方式：左对齐  居中   右对齐
      Vue.prototype.getaligntype = function () {
        return ['左对齐', '居中', '右对齐']
      },
      // 位置： 上  下  左 右  上居中  底居中  左居中  右居中
      Vue.prototype.getweizhiinfo = function () {
        var weizhiinfo = ['上', '下', '左', '右', '上居中', '底居中', '左居中', '右居中']
        return weizhiinfo
      },
      //所有常用字体
      Vue.prototype.getallfontfamilies = function () {
        var allfonts = [
          /*{ name: 'serif', enname: 'serif'},*/
          { name: 'sans-serif', enname: 'sans-serif' },
          { name: 'cursive', enname: 'cursive' },
          { name: 'fantasy', enname: 'fantasy' },
          { name: 'monospace', enname: 'monospace' },
          { name: 'Arial', enname: 'Arial' },
          { name: '微软雅黑体', enname: 'Microsoft YaHei' },

          { name: 'Avenir', enname: 'Avenir' },
          { name: 'Arial', enname: 'Arial' },
          { name: 'Helvetica', enname: 'Helvetica' },
          { name: 'sans-serif', enname: 'sans-serif' },
          { name: '华文黑体', enname: 'STHeiti' },
          { name: '华文楷体', enname: 'STKaiti' },
          { name: '华文宋体', enname: 'STSong' },
          { name: '华文仿宋', enname: 'STFangsong' },
          { name: '黑体', enname: 'SimHei' },
          { name: '宋体', enname: 'SimSun' },
          { name: '新宋体', enname: 'NSimSun' },
          { name: '仿宋', enname: 'FangSong' },
          { name: '楷体', enname: 'KaiTi' },
          { name: '仿宋_GB2312', enname: 'FangSong_GB2312' },
          { name: '楷体_GB2312', enname: 'KaiTi_GB2312' },
          { name: '微软正黑体', enname: 'Microsoft JhengHei' },
          { name: '微软雅黑体', enname: 'Microsoft YaHei' },
          { name: '隶书', enname: 'LiSu' },
          { name: '幼圆', enname: 'YouYuan' },
          { name: '华文细黑', enname: 'STXihei' },
          { name: '华文楷体', enname: 'STKaiti' },
          { name: '华文宋体', enname: 'STSong' },
          { name: '华文中宋', enname: 'STZhongsong' },
          { name: '华文仿宋', enname: 'STFangsong' },
          { name: '方正舒体', enname: 'FZShuTi' },
          { name: '方正姚体', enname: 'FZYaoti' },
          { name: '华文彩云', enname: 'STCaiyun' },
          { name: '华文琥珀', enname: 'STHupo' },
          { name: '华文隶书', enname: 'STLiti' },
          { name: '华文行楷', enname: 'STXingkai' },
          { name: '华文新魏', enname: 'STXinwei' }

        ]
        return allfonts
      },
      //字号  8--40 (默认9)
      //颜色  颜色盘
      // 根据echart中的title的设置 获取aligntype的对齐方式
      Vue.prototype.getaligntypeByoption = function (titleobj) {
        var aligntype = '左对齐'
        if (titleobj.left == 'left') {
          aligntype = '左对齐'
        } else if (titleobj.left == 'right') {
          aligntype = '右对齐'
        } else if (titleobj.left == 'center') {
          aligntype = '居中'
        }
        return aligntype
      },
      // 判断图表是否可以合并  返回1表示可以  返回0表示不可以添加对比   -1不支持叠加对比   -2不支持平铺对比
      Vue.prototype.canmerge = function (option, name, chartinfo) {
        var ret = 1;
        let find = name.indexOf('条形图')
      if (find >= 0) { //条形图暂不支持对比2020    //20210707改为 条形图支持平铺添加
        if (chartinfo.modeltype == 'baseline') {
           ret = 1;
        }
        else if (chartinfo.addtype == 2 ) {
          ret = 1;
        } else {
          ret = -1;
        }
      } else if(name == '百分比堆积柱图') {
        ret = 1;
      } else if (name.indexOf('子弹图') >= 0 || name.indexOf('时序关系图') >= 0 || name.indexOf('瀑布图') >= 0 || name=='旭日图') {
        ret = 0
      } else if (chartinfo.addtype == 1 && chartinfo.modeltype == 'K线图') {
        ret = 0
      } else if (chartinfo.addtype == 1 && chartinfo.modeltype == 'baseline') {
        ret = 1
      } else if (chartinfo.modeltype1*1==2) {//业务模型图 不支持叠加
        ret = 0
      } else {
          // series中含有脚本函数的renderItem 不能合并
          if (Object.prototype.toString.call(option.series) == '[object Array]') {
            for (var i = 0; i < option.series.length; i++) {
              if (option.series[i].renderItem != undefined) {
                ret = 0
                break;
              }
            }

          } else if (Object.prototype.toString.call(option.series) == '[object Object]') {
            if (option.series.renderItem != undefined) {
              ret = 0
            }
          }
        }
        if (ret == 1) {
          //再检查被添加的图是否支持
          if (chartinfo.modeltype.indexOf('条形图') >= 0) {
            if(chartinfo.addtype == 2) {
              ret = 1;
            } else {
              ret = -1;
            }
          } else if (chartinfo.modeltype.indexOf('子弹图') >= 0) {
            ret = 0;
          } else if (chartinfo.modeltype.indexOf('时序关系图') >= 0) {
            ret = 0;
          }  else if (chartinfo.modeltype.indexOf('瀑布图') >= 0) {
            ret = 0;
          }
        }
        return ret
      },

      // 根据model数据，判断当前画布中是否有图存在
      // 图的个数，0表示没有图 >0表示有图
      Vue.prototype.isHavetubiao = function (models) {
        var havecnt = 0
        for (var i = 0; i < models.length; i++) {
          if (models[i].modeltype * 1 > 0) {
            havecnt = havecnt + 1
          }
        }  // for i
        return havecnt
      },
      Vue.prototype.isRealNum = function (val) {
        if (val === "" || val == null) {
          return false;
        }
        if (!isNaN(val)) {
          return true;
        }
        else {
          return false;
        }
      },
      //产生uuid
      Vue.prototype.genuuid = function () {
        var now = new Date();
        var year = now.getFullYear()
        var month = now.getMonth()
        var day = now.getDate()
        var h = now.getHours()
        var m = now.getMinutes()
        var s = now.getSeconds()

        var curday = '';
        month = month * 1 + 1
        if (month * 1 < 10)
          month = '0' + month
        if (day * 1 < 10)
          day = '0' + day
        if (h * 1 < 10)
          h = '0' + h
        if (m * 1 < 10)
          m = '0' + m
        if (s * 1 < 10)
          s = '0' + s
        curday = year + month + day + h + m + s
        var s1 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        var s2 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        return (curday + s1 + s2);
      },
      //在对象的数组中查找对象的key属性中查找字符串是否存在
      Vue.prototype.findStrinObj = function (myObjsz, key, findstr) {
        let findid = -1
        for (let i = 0; i < myObjsz.length; i++) {
          if (myObjsz[i][key] == findstr) {
            findid = i
            break
          }
        }//for i
        return findid
      },
      //在对象的数组中查找对象的key1 key2属性中查找字符串是否存在
      Vue.prototype.findStrinObjEx = function (myObjsz, key1, findstr1, key2, findstr2) {
      let findid = -1
      if (myObjsz == undefined) {
        return findid;
      }
        for (let i = 0; i < myObjsz.length; i++) {
          if (myObjsz[i][key1] == findstr1 && myObjsz[i][key2] == findstr2) {
            findid = i
            break
          }
        }//for i
        return findid
      },
      Vue.prototype.unique4 = function (arr) {
        arr.sort()
        var hash = [];
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i] === arr[j]) {
              ++i;
            }
          }
          hash.push(arr[i]);
        }
        return hash;
      },
      Vue.prototype.loginAndRedirectRoot = function (res, redirectToRoot) {
        if (redirectToRoot == null || redirectToRoot) {
          window.Vue.prototype.vm.$router.replace("/");
        }
        this.$cookies.set("userid", res.user.userId);
        this.$cookies.set("deptid", res.user.deptId);
        this.$cookies.set("name", res.user.userName);
        this.$cookies.set("deptName", res.user.dept["deptName"]);
        this.$cookies.set("deptType", res.user.dept["type"]);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("roles", res.roles);
        localStorage.setItem("permissions", res.permissions);
        if (redirectToRoot && res.autoLogin != null) {
          localStorage.setItem("autoLogin", res.autoLogin);
        }
        localStorage.setItem(
          "hl_api_token",
          "8e40792b-4021-5e08-a7fc-fd9cb5c9a8c5"
        ); //临时固定,从adpai库的apiToken表中取一个固定值
        this.$store.dispatch("GetInfo");
      },
      Vue.prototype.logout = function (notLogin) {
        this.$cookies.set("userid", "");
        this.$cookies.set("deptid", "");
        this.$cookies.set("name", "");
        this.$cookies.set("deptName", "");
        this.$cookies.set("deptType", "");
        this.$cookies.set("JSESSIONID", "");
        localStorage.setItem("user", "");
        localStorage.setItem("roles", "");
        localStorage.setItem("permissions", "");
        localStorage.setItem(
          "hl_api_token",
          "8e40792b-4021-5e08-a7fc-fd9cb5c9a8c5"
        ); //临时固定,从adpai库的apiToken表中取一个固定值
        if(!notLogin){
          window.Vue.prototype.vm.$router.push("/login");
        }
      },
      Vue.prototype.updateAvatar = function (avatar) {
        var user = JSON.parse(localStorage.getItem("user"));
        user.avatar = avatar;
        localStorage.setItem("user", JSON.stringify(user));
        this.$store.dispatch("GetInfo");
      },
      //返回true表示PC端，false表示手机端
      Vue.prototype.IsPCorPhone = function(){
        let userAgentInfo = navigator.userAgent;
        let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        let flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        //return false
        return flag;
      },
      Vue.prototype.getWindowHeight = function (isinterface) {
        let h;
        let min_height = 600;
        if(isinterface == 1) {
          min_height = 100;
        }
        let isPC = this.IsPCorPhone();
        if(isPC == true) {
          if (window.innerHeight) {
            h = window.innerHeight;
          } else if (document.documentElement != null && document.documentElement.clientHeight != null && document.documentElement.clientHeight != 0) {
            h = document.documentElement.clientHeight;
          } else if (document.body != null && document.body.clientHeight != null && document.body.clientHeight != 0) {
            h = document.body.clientHeight;
          } else {
            h = window.screen.height;
          }
          return Math.max(h, min_height);
        } else {
          h = window.screen.height
          return h
        }

      },
      Vue.prototype.getWindowWidth = function (isinterface) {
        let w;
        let isPC = this.IsPCorPhone();
        let min_width = 1250;
        if(isinterface == 1) {
          min_width = 100;
        }
        if(isPC == true) {
          if (window.innerWidth) {
            w = window.innerWidth;
          } else if (document.documentElement != null && document.documentElement.clientWidth != null && document.documentElement.clientWidth != 0) {
            w = document.documentElement.clientWidth;
          } else if (document.body != null && document.body.clientWidth != null && document.body.clientWidth != 0) {
            w = document.body.clientWidth;
          } else {
            w = window.screen.width;
          }
          return Math.max(w, min_width);
        } else {
          w = window.screen.width
          return w
        }
      },
      //根据option生成数据
      Vue.prototype.formatDataFromoption = function (option) {
        let datalist = { datas: [] }
        let title = '未命名'
        let header_display = [] //显示名
        let header_data = []
        let datas = []

        let classtype = ''
        if (option) {
          //获取title  作为文件名
          if (option.title) {
            classtype = Object.prototype.toString.call(option.title)
            if (classtype == '[object Array]') {
              if (option.title.length > 0) {
                title = option.title[0].text
                if (title == '' || title == undefined) {
                  title = '未命名'
                }
              }
            } else if (classtype == '[object Object]') {
              title = option.title.text
              if (title == '' || title == undefined) {
                title = '未命名'
              }
            }
          }
          //获取数据 以及数据的header
          //注意多个series的数据头
          let zuobiaoxi = getZuobiaoInfo(option)
          /// -1未知  0 无坐标系  1 直角  2 单轴  3 极坐标  4 雷达坐标 5 地理坐标 6 日历坐标  7 平行坐标  //关系类图
          let name = ''
          let m = 0
          let hh = 0
          if (option.series) {
            let seriex_classtype = Object.prototype.toString.call(option.series)
            if (zuobiaoxi == 0) {
              //判断一下是不是关系图
              if (seriex_classtype == '[object Object]') {
                if (option.series.type == 'graph'|| option.series.type == 'sankey') {
                  zuobiaoxi = 8
                }
              } else if (seriex_classtype == '[object Array]') {
                if (option.series[0]) {
                  if (option.series[0].type == 'graph'||option.series[0].type == 'sankey') {
                    zuobiaoxi = 8
                  }
                }
              }
            }
            if (zuobiaoxi == 0) {
              //无坐标系
              //检查是否有children
              let isChildren = 0;
              if (option.name == '矩形图' || option.name == '旭日图' || option.name == '树形图') {
                if (seriex_classtype == '[object Array]') {
                  for (let m = 0; m < option.series.length; m++) {
                    if (option.series[m].data) {
                      for (let i = 0; i < option.series[m].data.length; i++) {
                        if (option.series[m].data[i].children && option.series[m].data[i].children.length > 0) {
                          if (option.name == '树形图') {
                            for (let p = 0; p < option.series[m].data[i].children.length; p++) {
                              if (option.series[m].data[i].children[p] && option.series[m].data[i].children[p].children && option.series[m].data[i].children[p].children.length > 0) {
                                isChildren = 1;
                                break;
                              }
                            }
                          } else {
                            isChildren = 1;
                            break;
                          }
                        }
                      }//for i
                    }//for m
                  }
                } else if (seriex_classtype == '[object Object]') {
                  for (let m = 0; m < option.series.data.length; m++) {
                    if (option.series.data[m] && option.series.data[m].children && option.series.data[m].children.length > 0) {
                      if (option.name == '树形图') {
                        for (let p = 0; p < option.series.data[m].children.length;p++) {
                          if (option.series.data[m].children[p].children && option.series.data[m].children[p].children.length > 0) {
                            isChildren = 1;
                            break;
                          }
                        }//for p
                      } else {
                        isChildren = 1;
                        break;
                      }
                    }//for i
                  }//for m
                }
              }
              if (isChildren == 1) {
                header_display = ['name','name1','value'];
                if (seriex_classtype == '[object Array]') {
                  for (let m = 0; m < option.series.length; m++) {
                    if (option.series[m].data) {
                      if (m > 0) {
                        datas.push(['', '', '']);
                      }
                      for (let i = 0; i < option.series[m].data.length; i++) {
                        if (option.series[m].data[i].children && option.series[m].data[i].children.length > 0) {
                          if (option.name == '树形图') {
                            for (let q = 0; q < option.series[m].data[i].children.length; q++) {
                              let name = option.series[m].data[i].children[q].name;
                              for (let k = 0; k < option.series[m].data[i].children[q].children.length; k++) {
                                datas.push([name, option.series[m].data[i].children[q].children[k].name, option.series[m].data[i].children[q].children[k].value]);
                              }//for k
                            }
                          } else {
                            let name = option.series[m].data[i].name;
                            for (let k = 0; k < option.series[m].data[i].children.length; k++) {
                              datas.push([name, option.series[m].data[i].children[k].name, option.series[m].data[i].children[k].value]);
                            }//for k
                          }
                        }
                      }//for i
                    }//for m
                  }
                } else if (seriex_classtype == '[object Object]') {
                  for (let m = 0; m < option.series.data.length; m++) {
                    if (option.series.data[m] && option.series.data[m].children && option.series.data[m].children.length > 0) {
                      if (option.name == '树形图') {
                        for (let q = 0; q < option.series.data[m].children.length; q++) {
                            let name = option.series.data[m].children[q].name;
                            for (let p = 0; p < option.series.data[m].children[q].children.length; p++) {
                              datas.push([name, option.series.data[m].children[q].children[p].name, option.series.data[m].children[q].children[p].value]);
                            }
                        }
                      } else {
                        let name = option.series.data[m].name;
                        for (let k = 0; k < option.series.data[m].children.length; k++) {
                          datas.push([name, option.series.data[m].children[k].name, option.series.data[m].children[k].value]);
                        }
                      }
                    }//for i
                  }//for m
                }
              } else {
                if (seriex_classtype == '[object Array]') {
                  if (option.series.length > 0) {
                    name = option.series[0].name
                    if (name == '' || name == undefined) {
                      name = 'Series0'
                    }
                    header_display.push(name)
                    header_display.push('value')
                    for (m = 0; m < option.series.length; m++) {
                      if (option.series[m].data) {
                        if (m > 0) {
                          name = option.series[m].name
                          if (name == '' || name == undefined) {
                            name = 'Series' + m
                          }
                          datas.push(['', ''])
                          datas.push([name, 'value'])
                        }
                        if (option.name == '树形图') {
                          if (option.series[m].data[0] && option.series[m].data[0].children) {
                            let tmpdatas = option.series[m].data[0].children.map(function (item) { return [item.name, item.value] })
                            datas = datas.concat(tmpdatas)
                          }
                        } else {
                          let tmpdatas = option.series[m].data.map(function (item) { return [item.name, item.value] })
                          datas = datas.concat(tmpdatas)
                        }
                      } // if [m].data
                    } // for m
                  }
                } else if (seriex_classtype == '[object Object]') {
                  if (option.series.data) {
                    name = option.series.name
                    if (name == '' || name == undefined) {
                      name = 'Series0'
                    }
                    header_display.push(name)
                    header_display.push('value')
                    if (option.name == '树形图') {
                      if (option.series.data && option.series.data[0] && option.series.data[0].children) {
                        datas = option.series.data[0].children.map(function (item) { return [item.name, item.value] })
                      }
                    } else {
                      if (option.series.data) {
                        datas = option.series.data.map(function (item) { return [item.name, item.value] })
                      }
                    }
                  }
                }
              }
              if (datas.length > 0) {
                datalist.datas = datas
                datalist.title = title
                datalist.header = header_display
              }
            } else if (zuobiaoxi == 1) {
              //直角坐标系
              let x_classtype = Object.prototype.toString.call(option.xAxis)
              let y_classtype = Object.prototype.toString.call(option.yAxis)
              let grid_classtype = Object.prototype.toString.call(option.grid)
              let main_zhou = this.checkMainAxis(option)
              let zhou_data = []
              let series_data = []

              if (main_zhou == 'xAxis') {
                if (x_classtype == '[object Object]') {
                  zhou_data = option.xAxis.data
                } else if (x_classtype == '[object Array]') {
                  zhou_data = option.xAxis[0].data
                }
              } else if (main_zhou == 'yAxis') {
                if (y_classtype == '[object Object]') {
                  zhou_data = option.yAxis.data
                } else if (y_classtype == '[object Array]') {
                  zhou_data = option.yAxis[0].data
                }
              }

              if (seriex_classtype == '[object Object]') {

                //header_display.push()
                let name = option.series.name
                if (name == '' || option.series == undefined) {
                  name = 'Series0'
                }
                //第一项是轴上的数据  第二项是值
                header_display = ['', name]

                if (option.series.data) {
                  if (option.series.data.length > 0) {
                    //有值
                    series_data = option.series.data
                    datas = series_data.map(function (item, index) {
                      let zhou_value = ''
                      let s_value = ''
                      if (zhou_data[index]) {
                        zhou_value = zhou_data[index]
                      }
                      if (Object.prototype.toString.call(item) == '[object String]' || Object.prototype.toString.call(item) == '[object Number]') {
                        s_value = item
                      } else if (Object.prototype.toString.call(item) == '[object Object]') {
                        s_value = item.value
                        if (s_value == undefined) {
                          s_value = ''
                        }
                      }
                      return [zhou_value, s_value]
                    })
                  }
                }


              } else if (seriex_classtype == '[object Array]') {
                header_display.push('')
                name = ''
                if (option.series.length > 0) {
                  for (m = 0; m < option.series.length; m++) {
                    name = option.series[m].name
                    if (name == '' || name == undefined) {
                      name = 'Series' + m;
                    }
                    header_display.push(name)
                  }//for m

                  datas = zhou_data.map(function (item, index) {
                    let onelist = []
                    let value_classtype = ''
                    if (item != undefined) {
                      onelist.push(item)
                      for (m = 0; m < option.series.length; m++) {
                        if (option.series[m].data) {
                          if (option.series[m].data[index]) {
                            value_classtype = Object.prototype.toString.call(option.series[m].data[index])
                            if (value_classtype == '[object String]' || value_classtype == '[object Number]') {
                              onelist.push(option.series[m].data[index])
                            } else if (value_classtype == '[object Object]') {
                              if (Object.prototype.toString.call(option.series[m].data[index].value)) {
                                onelist.push(option.series[m].data[index].value)
                              } else {
                                onelist.push(' ')
                              }
                            } else {
                              onelist.push(' ')
                            }

                          } else {
                            onelist.push(' ')
                          }
                        } else {
                          onelist.push(' ')
                        }
                      }//for mm
                    }
                    return onelist
                  })
                }
              }
              if (datas.length > 0) {
                datalist.datas = datas
                datalist.title = title
                datalist.header = header_display
              }
            } else if (zuobiaoxi == 2) {
              //单轴
              header_display = ['轴', '值'];
              let singleAxisData = [];
              if (option && option.singleAxis) {
                let axisType = Object.prototype.toString.call(option.singleAxis);
                if (axisType == '[object Object]') {
                  singleAxisData = option.singleAxis.data;
                } else if (axisType == '[object Array]') {
                  if (option.singleAxis[0]) {
                    singleAxisData = option.singleAxis[0].data;
                  }
                }
              }
              if (singleAxisData && singleAxisData.length > 0) {
                if (option && option.series) {
                  for (let i = 0; i < option.series.length; i++) {
                    for (let m = 0; m < option.series[i].data.length; m++) {
                      datas.push([singleAxisData[m] ,option.series[i].data[m]]);
                    }
                  }
                }
              }
              if (datas.length > 0) {
                datalist.datas = datas
                datalist.title = title
                datalist.header = header_display
              }
            } else if (zuobiaoxi == 3) {//极坐标
              header_display = ['name', 'value'];
              let datatype = '';
              let curvalue = '';
              if (option.name == '靶心图') {
                if (option.series) {
                  for (let i = 0; i < option.series.length; i++) {
                    for (let m = 0; m < option.series[i].data.length; m++) {
                      datatype = Object.prototype.toString.call(option.series[i].data[m]);
                      if (datatype == '[object Object]') {
                        curvalue = option.series[i].data[m].value;
                      } else if (datatype == '[object Array]') {
                        curvalue = option.series[i].data[m];
                      }
                      if (curvalue && curvalue.length >= 2) {
                        datas.push([curvalue[1],curvalue[0]]);
                      }
                    }//for m
                  }
                }
              }
              if (datas.length > 0) {
                datalist.datas = datas
                datalist.title = title
                datalist.header = header_display
              }
            } else if (zuobiaoxi == 4) {
              //雷达
              header_display = ['']
              let indicator = undefined
              if (Object.prototype.toString.call(option.radar) == '[object Object]') {
                indicator = option.radar.indicator
              } else if (Object.prototype.toString.call(option.radar) == '[object Array]') {
                if (option.radar[0])
                  indicator = option.radar[0].indicator
              }
              if (indicator) {
                for (m = 0; m < indicator.length; m++) {
                  if (indicator[m].name != undefined) {
                    header_display.push(indicator[m].name)
                  } else {
                    header_display.push('Series' + m)
                  }
                }// for mm

                if (Object.prototype.toString.call(option.series) == '[object Object]') {
                  let onelist = []
                  if (option.series.data) {
                    for (m = 0; m < option.series.data.length; m++) {
                      if (option.series.data[m].name != undefined) {
                        onelist.push(option.series.data[m].name)
                      } else {
                        onelist.push('')
                      }
                      onelist = onelist.concat(option.series.data[m].value)
                      datas.push(onelist)
                    }//for mm
                  }
                } else if (Object.prototype.toString.call(option.series) == '[object Array]') {
                  let onelist = []
                  for (m = 0; m < option.series.length; m++) {
                    if (option.series[m].data) {
                      for (hh = 0; hh < option.series[m].data.length; hh++) {
                        if (option.series[m].data[hh].name != undefined) {
                          onelist.push(option.series[m].data[hh].name)
                        } else {
                          onelist.push('')
                        }
                        onelist = onelist.concat(option.series[m].data[hh].value)
                        datas.push(onelist)
                      }// hh
                    }
                  }// fro mm
                }
              }
              if (datas.length > 0) {
                datalist.datas = datas
                datalist.title = title
                datalist.header = header_display
              }
            } else if (zuobiaoxi == 8) {
              //关系图
              let value = ''
              header_display = ['source', 'target', 'value']
              if (seriex_classtype == '[object Object]') {
                datas = option.series.links.map(function (item, index) {
                  value = ''
                  if (item.value != undefined) {
                    value = item.value
                  }
                  return [item.source, item.target, value]
                })
              } else if (seriex_classtype == '[object Array]') {
                let one_s_data = []
                for (m = 0; m < option.series.length; m++) {
                  one_s_data = option.series[m].links.map(function (item, index) {
                    value = ''
                    if (item.value != undefined) {
                      value = item.value
                    }
                    return [item.source, item.target, value]
                  })
                  datas = datas.concat(one_s_data)
                }
              }
              if (datas.length > 0) {
                datalist.datas = datas
                datalist.title = title
                datalist.header = header_display
              }
            }
          }
        }

        return datalist
      },
      //根据配置信息获取到所有的字段 ，onedatasetsfield：一个图表的配置
      Vue.prototype.getAllFieldsFromDatasetting = function (oneDatasetsfield, fieldSettingTitle) {
        let allFields = [];
        if (oneDatasetsfield != undefined) {
          let i = 0
          let j = 0
          for (i = 0; i < oneDatasetsfield.length; i++) {
            if (oneDatasetsfield[i] != undefined && oneDatasetsfield[i] != null) {
              for (j = 0; j < oneDatasetsfield[i].length; j++) {
                if (oneDatasetsfield[i][j].name != fieldSettingTitle)
                  allFields.push(oneDatasetsfield[i][j].name)
              }//for j
            }
          }//for i
        }
        return allFields;
      },
      //K线图计算均线函数
      Vue.prototype.calculateMA = function (dayCount, data) {
        var result = [];
        for (var i = 0, len = data.length; i < len; i++) {
          if (i < dayCount) {
            result.push('-');
            continue;
          }
          if(data[i] && (data[i][1] == '-' || data[i][1] == undefined)) {
            result.push('-');
            continue;
          } else if(data[i] == undefined || data[i] == '-' || data[i] == '') {
            result.push('-');
            continue;
          }
          var sum = 0;
          let tmp_class = ''
          let dayCount_shiji = 0; //变成对比图后，有可能中间有停盘没有数据的情况，这时不能算做0
          for (var j = 0; j < dayCount; j++) {
            tmp_class = Object.prototype.toString.call(data[i - j])
            if (tmp_class == '[object Array]' && data[i - j].length >= 2) {
              if(isNaN(data[i - j][1])) {

              } else {
                sum += (data[i - j][1]) * 1;
                dayCount_shiji++;
              }
            }
          }//for j
          if(dayCount_shiji < dayCount) {
            //接着往前计算
            j = dayCount;
            let mm = 0;
            for(let m = 0; mm >=0 && dayCount_shiji < dayCount; m++) {
              mm = i-j-m;
              if(data[mm] == '' || isNaN(data[mm][1])) {
              }  else {
                sum += (data[mm][1]) * 1;
                dayCount_shiji++;
              }
            }//
          }
          result.push((sum / dayCount).toFixed(2));
        }
        return result;
      },
      //把对象中的key转化为单一key
    Vue.prototype.changeMulKey2SimpleKey = function (myObject) {
      if (Object.prototype.toString.call(myObject) == '[object String]' || Object.prototype.toString.call(myObject) == '[object Number]' || Object.prototype.toString.call(myObject) == '[object Array]') {
        return myObject
      }
      let retObject = {};//也可能是数组  如果第一层的key都是数字的话
      let myType = this.getTypeFromObj(myObject);
      if (myType == 'array') {
        retObject = [];
      }
      let key = ''
      for (key in myObject) {
        if (key.indexOf('.') > -1) {
          let key_arr = key.split('.');
          if (key_arr.length > 0) {
            let cur_object = retObject
            for (let kk = 0; kk < key_arr.length; kk++) {
              let tmp_key = key_arr[kk];
              if (kk == 0 && myType == 'array') {
                tmp_key = tmp_key * 1;
              }
              if(cur_object[tmp_key] == undefined)
                cur_object[tmp_key] = {}

              if (kk == key_arr.length - 1) {
                cur_object[tmp_key] = myObject[key]
              }
              cur_object = cur_object[tmp_key]
            }//kk
          } else {
            retObject[key] = myObject[key]
          }
        } else {
          retObject[key] = myObject[key]
        }
      }
      return retObject
      },
  //先判断第一层所有的key是不是都是数字类型，都是数字类型则返回 array   否则返回 object
    Vue.prototype.getTypeFromObj = function (myObject) {
      let retInfo = 'object';
      let isNumber = 1;
      let key = '';
      for (key in myObject) { 
        let key_arr = key.split('.');
        if (key_arr.length > 0) { 
          if (isNaN(key_arr[0] * 1)) {
            isNumber = 0;
            break;
          } else {//是数字
          }
        } else {
          isNumber = 0;
          break;
        }
      }
      if (isNumber == 1) {
        retInfo = 'array';
      }
      return retInfo;
    },
      
  //根据数组中某个属性值去重 获得新数组
  Vue.prototype.deleteRePeat = function(arrData,propertyName) {
    var arr1 = []
    let obj = {}
    for(var i = 0;i<arrData.length;i++){
      if (!obj[arrData[i][propertyName]]) {
        arr1.push(arrData[i]);
        obj[data[i][propertyName]] = true;
        }
    }
    return arr1;
  },
  //检查主轴是x轴还是y轴 返回值为：xAxis    yAxis
  Vue.prototype.checkMainAxis = function(option) {
      //主轴含有数据
      let type = '';
      let x_havedata= 0
      let y_havedata= 0
      let x_classtype = ''
      let y_classtype = ''
      let length = 0
      if(option.xAxis) {
          x_classtype = Object.prototype.toString.call(option.xAxis)
      }
      if(option.yAxis) {
          y_classtype = Object.prototype.toString.call(option.yAxis)
      }
      //判断x轴是否有数据
      if(x_classtype == '') {

      } else if (x_classtype == '[object Array]') {
          if(option.xAxis.length > 0) {
              if(option.xAxis[0].data) {
                  length = option.xAxis[0].data.length
                  if(length > 0) {
                      x_havedata = 1
                  }
              }
          }
      } else if(x_classtype == '[object Object]') {
          if(option.xAxis.data) {
              length = option.xAxis.data.length
              if(length > 0) {
                  x_havedata = 1
              }
          }
      }

      if(y_classtype == '') {

      } else if(y_classtype == '[object Array]') {
          if(option.yAxis.length > 0) {
              if(option.yAxis[0].data) {
                  length = option.yAxis[0].data.length
                  if(length > 0) {
                      y_havedata = 1
                  }
              }
          }
      } else if (y_classtype == '[object Object]') {
        if(option.yAxis.data) {
              length = option.yAxis.data.length
              if(length > 0) {
                  y_havedata = 1
              }
          }
      }
      if(x_havedata == 0 && y_havedata == 0) {
          type = '';//未知
      } else if(y_havedata == 0 && x_havedata == 1) {
          type = 'xAxis'
      } else if(x_havedata == 0 && y_havedata == 1) {
          type = 'yAxis'
      }
      return type
      }
  }
}
